"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : DIVIDER : STYLES --------------- ++++++++++ */


var _default = {
  divider: {
    backgroundColor: '#EEF2F6',
    display: 'block',
    width: '100%',
    height: (0, _index.pxToEm)(1),
    margin: '16px auto',
    // ----- sizes ----- //
    '&.size-full': {
      width: '100%'
    },
    '&.size-large': {
      width: '85%'
    },
    '&.size-medium': {
      width: '70%'
    },
    '&.size-small': {
      width: '50%'
    },
    '&.size-xsmall': {
      width: '25%'
    },
    // ----- colors ----- //
    // generates classes for every color in the theme ".color-(uniqueColor)"
    extend: (0, _index.themeStyleHelper)(_index.theme, 'color', function (theme, uniqueColor) {
      return {
        background: theme.color[uniqueColor].medium.swatch
      };
    })
  }
};
exports.default = _default;